import { arrayReplace } from "../../../utils";

export const getByValue = (
  key: string,
  value: any,
  records: any[] = [],
): any => {
  return records.find((item: any) => item[key] === value);
};

export const getByValues = (
  keys: string[],
  values: any[],
  records: any[] = [],
): any => {
  return records.find((item: any) =>
    keys.every((key, i) => item[key] === values[i]),
  );
};

export const getFilteredByValues = (
  keys: string[],
  values: any[],
  records: any[] = [],
): any => {
  return records.filter((item: any) =>
    keys.every((key, i) => item[key] === values[i]),
  );
};
export const getFilteredByValue = (
  key: string,
  value: string | number,
  records: any[] = [],
): any => {
  return getFilteredByValues([key], [value], records);
};

export const getFilteredByMultiValue = (
  key: string,
  values: any[],
  records: any[] = [],
): any => {
  return records.filter((item: any) => values.includes(item[key]));
};

export const addRecord = (record: any, previous: any[]): any[] => {
  return [...previous, record];
};

export const updateRecord = (
  index: number,
  record: any,
  previous: any[],
): any[] => {
  return arrayReplace(previous, index, record);
};

export const saveRecords = async (
  keys: string | string[],
  records: any[],
  setter: (records: any[]) => Promise<any>,
  previous: any[] = [],
): Promise<any[]> => {
  const newRecords = records.reduce((acc: any, record: any) => {
    let res;
    const wrappedKeys = Array.isArray(keys) ? keys : [keys];
    const index = previous.findIndex((item: any) =>
      wrappedKeys.every((key: string) => item[key] === record[key]),
    );
    if (index !== -1) {
      res = updateRecord(index, record, acc);
    } else {
      res = addRecord(record, acc);
    }
    return res;
  }, previous);
  await setter(newRecords);
  return newRecords;
};

export const saveRecord = (
  key: string | string[],
  record: any,
  setter: (records: any[]) => Promise<any>,
  previous: any[] = [],
): Promise<any> => {
  return saveRecords(key, [record], setter, previous);
};

export const patchRecords = (
  primaryKey: string,
  key: any | any[],
  value: string | string[],
  fieldsToPatch: any,
  setter: (records: any[]) => Promise<any>,
  previous: any[] = [],
): Promise<any> => {
  const keys = Array.isArray(key) ? key : [key];
  const values = Array.isArray(value) ? value : [value];
  const records = getFilteredByValues(keys, values, previous);
  const patchedRecords = records.map((record: any) => {
    return { ...record, ...fieldsToPatch };
  });
  return saveRecords(primaryKey, patchedRecords, setter, previous);
};

export const patchRecord = (
  primaryKey: string,
  key: any | any[],
  value: any | any[],
  fieldsToPatch: any,
  setter: (records: any[]) => Promise<any>,
  previous: any[] = [],
): Promise<any> => {
  const keys = Array.isArray(key) ? key : [key];
  const values = Array.isArray(value) ? value : [value];
  const record = getByValues(keys, values, previous);
  return saveRecord(
    primaryKey,
    { ...record, ...fieldsToPatch },
    setter,
    previous,
  );
};

export const removeMultiple = (
  key: string,
  values: any[],
  setter: (records: any[]) => Promise<any>,
  records: any[] = [],
): Promise<any[]> => {
  return setter(
    [...records].filter((item: any) => !values.includes(item[key])),
  );
};
export const remove = (
  key: string,
  value: any,
  setter: (records: any[]) => Promise<any>,
  records: any[] = [],
): Promise<any[]> => {
  return removeMultiple(key, [value], setter, records);
};
